window.dataLayer = window.dataLayer || [];

(function init () {
  setConsentDefault()

  const storedConsent = getSessionStorageConsent()

  if (!storedConsent) return

  const cookies = document.cookie.split(';')
  const hasGaCookie = cookies.some(cookie => cookie.trim().substring(0, 3) === '_ga')

  if (!hasGaCookie) return

  setConsentUpdate(storedConsent)
})()

function setConsentDefault () {
  const consentStatus = getConsentStatus()
  consentStatus.wait_for_update = 500

  window.dataLayer.push(['consent', 'default', consentStatus])
}

function getUpdatedConsentStatus () {
  if (!window.Shopify?.customerPrivacy?.currentVisitorConsent) {
    console.error('Shopify.customerPrivacy.currentVisitorConsent not available - cannot get consent status')
    return
  }

  const { analytics, marketing, preferences } = window.Shopify.customerPrivacy.currentVisitorConsent()
  const consentStatus = getConsentStatus(analytics, marketing, preferences)

  return consentStatus
}

function setConsentUpdate (consentStatus) {
  window.dataLayer.push(['consent', 'update', consentStatus])

  const hasGrantedConsent = Object.keys(consentStatus).some(key => key !== 'security_storage' && consentStatus[key] === 'granted')

  if (!hasGrantedConsent) return

  window.dataLayer.push({
    event: 'consent_granted',
    categories: {
      ...consentStatus,
    },
    timestamp: new Date().toISOString(),
  })
}

function handleConsentUpdate () {
  const updatedConsent = getUpdatedConsentStatus()
  const storedConsent = getSessionStorageConsent()

  const consentHasChanged = JSON.stringify(storedConsent) !== JSON.stringify(updatedConsent)

  if (!consentHasChanged) return

  setConsentUpdate(updatedConsent)
  setSessionStorageConsent(updatedConsent)
}

function setSessionStorageConsent (consentValues) {
  const consentString = JSON.stringify(consentValues)
  sessionStorage.setItem('BAO-consentValues', consentString)
}

function getSessionStorageConsent () {
  const consentString = sessionStorage.getItem('BAO-consentValues')
  return consentString ? JSON.parse(consentString) : null
}

function getConsentStatus (analytics = '', marketing = '', preferences = '') {
  return {
    ad_user_data: marketing === 'yes' ? 'granted' : 'denied',
    ad_storage: marketing === 'yes' ? 'granted' : 'denied',
    ad_personalization: marketing === 'yes' ? 'granted' : 'denied',
    analytics_storage: analytics === 'yes' ? 'granted' : 'denied',
    functionality_storage: preferences === 'yes' ? 'granted' : 'denied',
    personalization_storage: marketing === 'yes' ? 'granted' : 'denied',
    security_storage: 'granted',
  }
}

// Load Shopify's consent-tracking API to watch for consent changes
window.Shopify.loadFeatures(
  [{ name: 'consent-tracking-api', version: '0.1' }],
  (error) => {
    if (error) {
      console.error('Error loading Shopify consent API:', error)
      return
    }

    const customEvent = new CustomEvent('consent-tracking-api-loaded')
    document.dispatchEvent(customEvent)

    document.addEventListener('visitorConsentCollected', () => {
      handleConsentUpdate()
    })
  },
)
